<script setup lang="ts">
import VueJsonPretty from 'vue-json-pretty'
import type { JSONDataType } from 'vue-json-pretty/types/utils'

import 'vue-json-pretty/lib/styles.css'

interface Props {
  value: JSONDataType
}

defineProps<Props>()
</script>

<template>
  <div>
    <VueJsonPretty
      :data="value"
      :deep="1"
      show-icon
    />
  </div>
</template>
